"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[131],{

/***/ 2582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageLayout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.3_65aaefrptgalbi6a2fwpzxfmae/node_modules/next/head.js
var head = __webpack_require__(9327);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.3_65aaefrptgalbi6a2fwpzxfmae/node_modules/next/image.js
var next_image = __webpack_require__(7659);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.4.0_react@18.2.0/node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(1284);
// EXTERNAL MODULE: ./content/links.ts
var links = __webpack_require__(2304);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(5924);
;// CONCATENATED MODULE: ./components/footer/FooterIconLink.tsx



function FooterIconLink(param) {
    var children = param.children, platform = param.platform, className = param.className;
    var ref;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: (0,clsx_m/* default */.Z)(className),
        target: "_blank",
        rel: "noreferrer",
        "aria-label": (0,clsx_m/* default */.Z)(platform),
        href: (ref1 = (ref = links/* socials.find */.UY.find(function(e) {
            return e.name === platform;
        })) === null || ref === void 0 ? void 0 : ref.url) !== null && ref1 !== void 0 ? ref1 : "#",
        children: children
    });
};

// EXTERNAL MODULE: ./components/ui/CustomLink.tsx
var CustomLink = __webpack_require__(5115);
;// CONCATENATED MODULE: ./components/footer/Footer.tsx






function Footer() {
    var ref = (0,react.useState)(0), counter = ref[0], setCounter = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "my-8 text-center text-knut-light-text dark:text-knut-dark-text",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                width: 128 + (counter > 5 ? counter * 3 : 0),
                height: 128 + (counter > 5 ? counter * 3 : 0),
                alt: "Knut",
                src: "/knut3head.webp",
                onClick: function() {
                    return setCounter(counter + 1);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-4 flex flex-col items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Camp Knut 2022"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                href: "/contributors",
                                type: "Link",
                                lightColor: "text-knut-light-header",
                                darkColor: "dark:text-knut-dark-header",
                                children: "Contributors"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-4xl my-2 flex flex-row items-center justify-center gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterIconLink, {
                                    platform: "Twitch",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaTwitch */.aWC, {
                                        size: 26,
                                        className: "transition duration-300 hover:text-knut-other-twitch"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterIconLink, {
                                    platform: "Reddit",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaReddit */.hrS, {
                                        size: 26,
                                        className: "transition duration-300 hover:text-knut-other-reddit"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterIconLink, {
                                    platform: "Youtube",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaYoutube */.V2E, {
                                        size: 26,
                                        className: "transition duration-300 hover:text-knut-other-youtube"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterIconLink, {
                                    platform: "Twitter",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
                                        size: 26,
                                        className: "transition duration-300 hover:text-knut-other-twitter"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterIconLink, {
                                    platform: "Instagram",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaInstagram */.Zf_, {
                                        size: 26,
                                        className: "transition duration-300 hover:text-knut-other-instagram"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterIconLink, {
                                    platform: "Merch",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaShoppingBag */.Xfy, {
                                        size: 26,
                                        className: "transition duration-300 hover:text-knut-other-merch"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "flex flex-row items-center justify-center gap-1 pb-0.5",
                children: [
                    "Made with ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaHeart */.$0H, {
                        className: "mx-0.5 hover:text-red-600"
                    }),
                    " on",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                        href: "https://github.com/Bitsnoxx/CampKnut",
                        type: "a",
                        darkColor: "dark:text-knut-dark-header",
                        lightColor: "text-knut-light-header",
                        children: "Github"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.3_65aaefrptgalbi6a2fwpzxfmae/node_modules/next/link.js
var next_link = __webpack_require__(5968);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-themes@0.2.0_53oqlnqnxhbetdy4ljlkkvmoby/node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(9155);
;// CONCATENATED MODULE: ./components/ThemeSwitch.tsx



function ThemeSwitch(param) {
    var className = param.className;
    var ref = (0,index_module/* useTheme */.F)(), theme = ref.theme, setTheme = ref.setTheme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: className,
            onClick: function() {
                setTheme(theme === "light" ? "dark" : "light");
            },
            children: theme && theme === "dark" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaSun */.Mei, {
                size: 19,
                title: "Get flash-banged"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaMoon */.TLr, {
                size: 19,
                title: "Switch to gamer mode"
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/header/Header.tsx





function Header() {
    var ref = (0,react.useState)(false), active = ref[0], setActive = ref[1];
    var handleClick = function() {
        setActive(!active);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "sticky top-0 z-10 w-full bg-knut-light-bg text-knut-light-text dark:bg-knut-dark-bg dark:text-knut-dark-text",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                href: "public/icons/knut3head-96x96.webp"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "relative flex flex-wrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full lg:hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: handleClick,
                                    className: "text-xl cursor-pointer px-4 py-6 align-top",
                                    type: "button",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "relative block h-px w-6 rounded-sm bg-knut-dark-bg dark:bg-knut-light-bg "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "relative mt-1 block h-px w-6 rounded-sm bg-knut-dark-bg dark:bg-knut-light-bg"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "relative mt-1 block h-px w-6 rounded-sm bg-knut-dark-bg dark:bg-knut-light-bg"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeSwitch, {
                                    className: "text-xl px-4 py-5 font-black uppercase leading-snug text-knut-light-header hover:opacity-75 dark:text-knut-dark-header"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)(active ? "flex" : "hidden", "grow lg:flex"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "flex list-none flex-col px-4 lg:mx-auto lg:flex-row lg:items-center lg:justify-center lg:gap-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-sm flex cursor-pointer items-center py-4 font-bold uppercase leading-snug hover:opacity-75 ",
                                                children: "Home"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/calendar",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-sm flex cursor-pointer items-center py-4 font-bold uppercase leading-snug hover:opacity-75",
                                                children: "Calendar"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/exercises",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-sm flex cursor-pointer items-center py-4 font-bold uppercase leading-snug hover:opacity-75",
                                                children: "Exercises"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/workout",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-sm flex cursor-pointer items-center py-4 font-bold uppercase leading-snug hover:opacity-75",
                                                children: "Workout"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/content",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-sm flex cursor-pointer items-center py-4 font-bold uppercase leading-snug hover:opacity-75",
                                                children: "Content"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/vote",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-sm flex cursor-pointer items-center py-4 font-bold uppercase leading-snug hover:opacity-75",
                                                children: "Vote"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://store.streamelements.com/knut",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            className: "text-sm flex cursor-pointer items-center py-4 font-bold uppercase leading-snug hover:opacity-75",
                                            children: "Merch"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeSwitch, {
                                            className: "hidden cursor-pointer items-center py-4 text-knut-light-header hover:opacity-75 dark:text-knut-dark-header lg:flex"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/layout/PageLayout.tsx





function PageLayout(param) {
    var children = param.children, _widthClassName = param.widthClassName, widthClassName = _widthClassName === void 0 ? "max-w-5xl" : _widthClassName, openGraph = param.openGraph;
    var ref, ref1, ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            " ",
                            openGraph === null || openGraph === void 0 ? void 0 : openGraph.title
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: openGraph === null || openGraph === void 0 ? void 0 : openGraph.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: openGraph === null || openGraph === void 0 ? void 0 : openGraph.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: openGraph === null || openGraph === void 0 ? void 0 : openGraph.type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: openGraph === null || openGraph === void 0 ? void 0 : openGraph.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:locale",
                        content: openGraph === null || openGraph === void 0 ? void 0 : openGraph.locale
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: openGraph === null || openGraph === void 0 ? void 0 : (ref = openGraph.image) === null || ref === void 0 ? void 0 : ref.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:type",
                        content: openGraph === null || openGraph === void 0 ? void 0 : (ref1 = openGraph.image) === null || ref1 === void 0 ? void 0 : ref1.type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:height",
                        content: openGraph === null || openGraph === void 0 ? void 0 : (ref2 = openGraph.image) === null || ref2 === void 0 ? void 0 : ref2.height
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:width",
                        content: openGraph === null || openGraph === void 0 ? void 0 : (ref3 = openGraph.image) === null || ref3 === void 0 ? void 0 : ref3.width
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: openGraph === null || openGraph === void 0 ? void 0 : (ref4 = openGraph.image) === null || ref4 === void 0 ? void 0 : ref4.alt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: openGraph === null || openGraph === void 0 ? void 0 : openGraph.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: openGraph === null || openGraph === void 0 ? void 0 : openGraph.site_name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@Knutspild"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: openGraph === null || openGraph === void 0 ? void 0 : openGraph.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: openGraph === null || openGraph === void 0 ? void 0 : openGraph.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: openGraph === null || openGraph === void 0 ? void 0 : openGraph.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: openGraph === null || openGraph === void 0 ? void 0 : (ref5 = openGraph.image) === null || ref5 === void 0 ? void 0 : ref5.url
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex min-h-screen flex-col bg-knut-light-bg font-inter text-knut-light-text dark:bg-knut-dark-bg dark:text-knut-dark-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: (0,clsx_m/* default */.Z)("container mx-auto flex-1 p-4", widthClassName),
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 5115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5968);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5924);



var defaultStyle = {
    lightColor: "text-knut-light-text",
    darkColor: "dark:text-knut-dark-text",
    hover: "hover:underline"
};
function CustomLink(param) {
    var children = param.children, type = param.type, href = param.href, _lightColor = param.lightColor, lightColor = _lightColor === void 0 ? defaultStyle.lightColor : _lightColor, _darkColor = param.darkColor, darkColor = _darkColor === void 0 ? defaultStyle.darkColor : _darkColor, _hover = param.hover, hover = _hover === void 0 ? defaultStyle.hover : _hover, className = param.className;
    if (type === "a") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: "_blank",
            rel: "noreferrer",
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, lightColor, darkColor, hover),
            children: children
        });
    }
    if (type === "Link") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, lightColor, darkColor, hover),
            children: children
        })
    });
    return null;
};


/***/ }),

/***/ 2304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FH": function() { return /* binding */ baseUrl; },
/* harmony export */   "UY": function() { return /* binding */ socials; }
/* harmony export */ });
/* unused harmony export placeHolderImage */
var baseUrl =  true ? "https://".concat("beta.campknut.gg") : 0;
var socials = [
    {
        name: "Twitch",
        url: "https://twitch.tv/knut",
        inNavbar: true
    },
    {
        name: "Discord",
        url: "https://discord.gg/knut",
        inNavbar: true
    },
    {
        name: "Merch",
        url: "https://strms.net/CampKnut",
        inNavbar: true
    },
    {
        name: "Youtube",
        url: "https://www.youtube.com/c/Knutspild",
        inNavbar: true
    },
    {
        name: "Twitter",
        url: "https://twitter.com/Knutspild",
        inNavbar: true
    },
    {
        name: "Reddit",
        url: "https://www.reddit.com/r/KnutTwitch/"
    },
    {
        name: "Instagram",
        url: "https://www.instagram.com/knutspild/"
    }, 
];
var placeHolderImage = "/404.webp";


/***/ }),

/***/ 9862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": function() { return /* binding */ seo; },
/* harmony export */   "R0": function() { return /* binding */ errors; },
/* harmony export */   "eF": function() { return /* binding */ introduction; },
/* harmony export */   "q4": function() { return /* binding */ tips; }
/* harmony export */ });
var introduction = {
    title: "Camp Knut",
    whatIs: "Camp Knut is a 30-day long training camp, where a group of streamers tries to follow Knut's workout routine and diet.",
    goal: "Improve fitness, look and health as much as possible in 30 days. The final show will be a fitness/bodybuilding competition.",
    whoIsKnut: "Knut is a streamer from Norway. He is a professional bodybuilder and a fitness enthusiast."
};
var tips = {
    knowYourLimits: "Remember to take care of your health, you know your own limits\n  better than anyone else. If you end up injuring yourself, it\n  will only set you further back.",
    supplements: "Supplements aren't needed, but if you have the money and want to\n  maximize your workouts - Go for it!"
};
var errors = {
    missingPage: "We couldn't find that page",
    serverError: "Server error, that's awkward. That wasn't supposed to happen"
};
var seo = {
    description: "Camp Knut is a 30-day long training camp where Knut will take Mizkif, Nmplol, EsfandTV, Cyr, Lacari, Tectone and Erobb221 through a full bodybuilding experience. By the end of the\n  training camp, they will go on a bodybuilding show. They will also be judged by their performance by Knut, WakeWilder, Malena and Asmongold.",
    title: introduction.title
};


/***/ })

}]);